import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';

import TextInput from '../Inputs/TextInput';

const styles = ({ palette }) => ({
  inputGroup: {
    width: '100%'
  },
  input: palette.input,
  postfix: {
    color: palette.text.color,
    background: palette.disabled
  }
});

function FormInput({
  input: { value, onChange }, meta: { valid, submitFailed }, title, placeholder, componentClass, prefix, postfix, type,
  mouseInKey, isRequired, errorMessage, disabled, classes, containerClass, ...other
}) {
  return (
    <TextInput
    label={title}
    value={value}
    type={type}
    isValid={!submitFailed || valid}
    prefix={prefix}
    postfix={postfix}
    onChange={onChange}
    containerClassName={containerClass}
    className={componentClass}
    placeholder={placeholder}
    disabled={disabled}
    errorText={errorMessage}
    mouseInKey={mouseInKey}
    isRequired={isRequired}
    {...other}
  />
  );
}

FormInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  componentClass: PropTypes.string,
  prefix: PropTypes.string,
  postfix: PropTypes.string,
  classes: PropTypes.object,
  type: PropTypes.string,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  mouseInKey: PropTypes.string,
  disabled: PropTypes.bool,
  containerClass: PropTypes.string
};

FormInput.defaultProps = {
  meta: {
    valid: true,
    submitFailed: false
  },
  title: '',
  placeholder: '',
  componentClass: 'input',
  prefix: null,
  postfix: null,
  classes: {},
  type: 'text',
  isRequired: false,
  errorMessage: null,
  mouseInKey: '',
  disabled: false,
  containerClass: ''
};

FormInput.displayName = 'FormInput';

export default withStyles(styles)(FormInput);